import Container from 'olive-react-myoneui/lib/Container';

function CourseBundleDescription({
  className,
  courseBundleDescTitle,
  courseBundleDesc,
}) {
  return (
    <div className={`${className || ''} bundle-courses-description mk-base-desc-bundle-courses p-0`}>
      <h4 className="fw-bold mk-course-overview-title">{courseBundleDescTitle}</h4>
      <p dangerouslySetInnerHTML={{ __html: courseBundleDesc }} />
    </div>
  );
}

export default CourseBundleDescription;
